import { fetchWithTimeout } from "./Timeout";
import { CheckSessionTimeout } from "./CheckSessionTimeout";

export async function AddPortfolioLineItem(portfolio_id, symbol, quantity) {
    
    const Token = sessionStorage.getItem("Token");
    const header = { Authorization: `Bearer ${Token}`};

    var raw = JSON.stringify({
        session_id: Token,
        symbol: symbol,
        quantity: quantity,
        portfolio_id: portfolio_id
    });

    var requestOptions = {
        method: "POST",
        body: raw,
        headers: header,
        redirect: "follow",
    };
    if (!CheckSessionTimeout(Token)){
        try {
            const response = await fetchWithTimeout(
                process.env.REACT_APP_PORTFOLIO_LINEITEM_API,
                requestOptions
            );
            const message = await response.json();
            if (!response.ok) {
                return { status: response.status, error: message.error || message };
            } else {
                return { status: response.status, result: message.result };
            }
        } catch (error) {
            return { status: 0, error: error.message };
        }
    } else {
        return { status: 401 };
    }
}
